import React from 'react'

const DuplicateIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M16.4 2H2.8C2.3584 2 2 2.3584 2 2.8V16.4C2 16.8416 2.3584 17.2 2.8 17.2H16.4C16.8416 17.2 17.2 16.8416 17.2 16.4V2.8C17.2 2.3584 16.8416 2 16.4 2ZM15.6 15.6H3.6V3.6H15.6V15.6Z"
            fill={color}
        />
        <path d="M20.4004 18.4V20.4H18.4004V22H21.2004C21.642 22 22.0004 21.6416 22.0004 21.2V18.4H20.4004Z" fill={color} />
        <path d="M16.552 20.4H12.248V22H16.552V20.4Z" fill={color} />
        <path d="M8.40078 20.4V18.4H6.80078V21.2C6.80078 21.6416 7.15918 22 7.60078 22H10.4008V20.4H8.40078Z" fill={color} />
        <path d="M21.2004 6.80005H18.4004V8.40005H20.4004V10.4H22.0004V7.60005C22.0004 7.15845 21.642 6.80005 21.2004 6.80005Z" fill={color} />
        <path d="M22.0004 12.248H20.4004V16.552H22.0004V12.248Z" fill={color} />
    </svg>
)

export default DuplicateIcon
